import React from "react";
import { Box } from "@mui/material";

import AccountsTable from "../AccountsTable";
import LogLoginsTable from "../LogLoginsTable";
import UniqueRegistrationIpTable from "../UniqueRegistrationIpTable";
import PaymentCards from "../PaymentCards";

const E2TAccountsInvestigation: React.FC = () => {
  return (
    <div>
      <div>
        <AccountsTable />
      </div>
      <Box component="hr" my="5px" />
      <Box display="grid" gridTemplateColumns="35% 15% 50%" columnGap="5px">
        <div>
          <LogLoginsTable />
        </div>
        <div>
          <UniqueRegistrationIpTable />
        </div>
        <div>
          <PaymentCards />
        </div>
      </Box>
    </div>
  );
};

export default E2TAccountsInvestigation;
